import React, { useState } from "react";

function SettingsPage() {
  const [ssid, setSsid] = useState("");
  const [password, setPassword] = useState("");
  const [port, setPort] = useState(null);
  const [status, setStatus] = useState("ยังไม่ได้เชื่อมต่อ");

  const handleRequestPort = async () => {
    try {
      const selectedPort = await navigator.serial.requestPort();
      await selectedPort.open({ baudRate: 115200 });
      setPort(selectedPort);
      setStatus("เชื่อมต่อแล้ว");
    } catch (err) {
      console.error(err);
      if (err.message.includes("already open")) {
        setStatus("พอร์ตนี้ถูกใช้งานอยู่แล้ว");
      } else {
        setStatus("เชื่อมต่อไม่สำเร็จ");
      }
    }
  };

  const handleSendWifi = async () => {
    if (!port || !port.writable) {
      alert("กรุณาเชื่อมต่อพอร์ตก่อน");
      return;
    }

    try {
      const payload = `WIFI:${ssid},${password}\n`;
      const writer = port.writable.getWriter();
      await writer.write(new TextEncoder().encode(payload));
      writer.releaseLock();

      await port.close();
      if (port.forget) {
        await port.forget();
      }
      setPort(null);
      setStatus("ส่งข้อมูลเรียบร้อยและปิดการเชื่อมต่อแล้ว");
    } catch (err) {
      console.error(err);
      setStatus("เกิดข้อผิดพลาดขณะส่งข้อมูล");
    }
  };

  const handleDisconnect = async () => {
    if (port) {
      try {
        await port.close();
        if (port.forget) {
          await port.forget();
        }
        setPort(null);
        setStatus("ยกเลิกการเชื่อมต่อแล้ว");
      } catch (err) {
        console.error(err);
        setStatus("ไม่สามารถปิดพอร์ตได้");
      }
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4">ตั้งค่า Wi-Fi สำหรับอุปกรณ์</h2>

      <div className="card p-4 mb-4 shadow">
        <h5 className="mb-3">เชื่อมต่อ Serial Port</h5>
        <div className="d-flex gap-3 flex-wrap">
          <button onClick={handleRequestPort} className="btn btn-primary">
            เลือกพอร์ต
          </button>
          <button onClick={handleDisconnect} className="btn btn-secondary">
            ยกเลิกการเชื่อมต่อ
          </button>
        </div>
        <div className="mt-3">สถานะ: {status}</div>
      </div>

      <div className="card p-4 shadow">
        <h5 className="mb-3">ตั้งค่า Wi-Fi สำหรับให้ ใช้งาน</h5>
        <div className="mb-3">
          <label className="form-label">ใส่ชื่อ Wi-Fi</label>
          <input
            type="text"
            className="form-control"
            value={ssid}
            onChange={(e) => setSsid(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">รหัสผ่าน Wi-Fi</label>
          <input
            type="text"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button onClick={handleSendWifi} className="btn btn-success">
          ส่งข้อมูลไปยัง ESP32
        </button>
      </div>
    </div>
  );
}

export default SettingsPage;
